<mode-access-denied *ngIf="isAccessDenied$ | async; else datasetViewComponent"></mode-access-denied>

<ng-template #datasetViewComponent>
  <mode-dataset-overview
    class="full-screen"
    *ngIf="datasetFacade.dataset$ | async as dataset; else loading"
    [main-content]
    [switchViewToken$]="switchViewToken$"
    [hideQueryLink]="true"
    [hideDatasetLink]="true"
    [showFieldDescriptionColumn]="true"
    [showQueryDependenciesBtn]="true"
    [showSyncBtn]="true"
    [showSyncFailedWarning]="true"
    [lastSynced]="(lastSynced$ | async) ?? ''"
    data-test="dataset-overview"
  >
    <mode-dataset-no-data noDataToView></mode-dataset-no-data>
    <mode-data-retention-no-data
      dataRetentionNoData
      [icon]="icon"
      [header]="header"
      [subtext]="subtext"
    ></mode-data-retention-no-data>
  </mode-dataset-overview>

  <ng-template #loading>
    <mode-loader class="loader"></mode-loader>
  </ng-template>
</ng-template>
